import * as React from "react";
import { Container } from "react-bootstrap";
import { withSnackbar } from "notistack";
import { PureComponent, Fragment } from "react";
import { BsArrowLeft } from "react-icons/bs";
import { subDirectory } from "../../config.json";
import NavBar from "../common/forms/NavbarCopy";
import { AddNotification } from "../Methods/Notificaition";
import {  SKBulkReceipt } from "../common/skeleton/subcatCardSkeleton";
import { getbookReceiptData,getBoatOtherTicket} from "../../services/PrintReceipt";
import { getLocalStorageValues } from "../../services/boat";
import CryptoJS from 'crypto-js';

class TripReceipt extends PureComponent {
    constructor(props) {
      super(props);
      this.state = {
        BoatOtherTicket: [],
        BookingBulkData: [],
        isBulkLoading: true,
        isBulkAvailable: false,
      };
    }
    componentDidMount = async () => {
        const params = new URLSearchParams(this.props.location.search);
        if (params) {
          const BoatHouseId = this.decryptedValuesFun(params.get("BHId"));
          const BookingId = this.decryptedValuesFun(params.get("BId"));
          const BookingDate = this.decryptedValuesFun(params.get("BD"));
          await this.setState({ BookingId, BoatHouseId, BookingDate });
          await this.getbookreceiptdata();
          await this.getBoatOtherTicket();
          
        } else {
          this.props.history.push({
            pathname: `${subDirectory}/boat`,
          });
        }
      };
    decryptedValuesFun = (value) => {
        if (!value) {
          return null;
        } else {
          value = value.replace(/-/g, '+').replace(/_/g, '/');
          const decrypted = CryptoJS.AES.decrypt(value, "1d207344b9238202821030788db04eae6526857bf49bf7620303e33756503131").toString(CryptoJS.enc.Utf8);
          if (decrypted) {
            return JSON.parse(decrypted);
          }
        }
      }
    getbookreceiptdata = async () => {
        let data = {
          QueryType: "BoatPrintTicketBulkReceipts",
          ServiceType: "B",
          UserId: getLocalStorageValues("UserId"),
          BookingDate: this.state.BookingDate,
          BookingId: this.state.BookingId,
          BoatHouseId: this.state.BoatHouseId,
        };
    
        const res = await getbookReceiptData(data);
    
        if (res.data.Table?.length >= 1) {
          this.setState({ BookingBulkData: res.data.Table });
          this.setState({ isBulkLoading: false,isBulkAvailable: true });
        } else {
          this.setState({ BookingBulkData: [],isBulkLoading: false, isBulkAvailable: false });
        }
    };
    getBoatOtherTicket = async () => {
        let data = {
          BookingId: this.state.BookingId,
          BoatHouseId: this.state.BoatHouseId,
          BookingType: "B",
        };
        const res = await getBoatOtherTicket(data);
    
        if (res.data.StatusCode === 1) {
          return this.setState({ BoatOtherTicket: res.data.Response });
        } else {
          return this.setState({ BoatOtherTicket: [] });
        }
      };
    render() {
        const {isBulkLoading,isBulkAvailable} = this.state;
        return (
            <Fragment>
                <AddNotification visible={this.state.openNotification} variant={this.state.variant} message={this.state.message} onClose={() => this.setState({ openNotification: false })} />
                <div>
                    <NavBar {...this.props} />
                    <div class="hotelReceipt">
                        <div className="d-flex hotelReceipt-wrapper ">
                        {this.state.BookingBulkData?.length >= 1 ? (
                            <Container fluid className="hotelReceipt-con  py-2">
                                <div className="initialpage">
                                    <div onClick={() => {this.props.history.push(`${subDirectory}/boatBookingHistory`);}}style={{ cursor: "pointer" }}>
                                        <BsArrowLeft className="ml-2 mr-2" />
                                            Go to Booking History
                                    </div>
                                    
                    
                                 </div>
                                <div class="receipt">
                                  {isBulkLoading && <SKBulkReceipt viewBox="0 0 450 500" />}
                                    {!isBulkLoading &&
                                        isBulkAvailable &&
                                        this.state.BookingBulkData?.map((bdata) => (
                                            <>
                                            <div className="rr-1">
                                                <div style={{ textAlign: "center",fontSize:"clamp(1rem, 2.5vw, 1.6rem)",fontWeight:600 }}>
                                                {bdata.BoatHouseName}
                                                </div>
                                                <div style={{ textAlign: "center",fontWeight:600,fontSize:"clamp(1rem, 2.5vw, 1.3rem)"}}>{bdata.BookingDate}</div>
                                                <div style={{ textAlign: "center",fontWeight:600,fontSize:"clamp(1rem, 2.5vw, 1.3rem)" }}>Booking : {bdata.PremiumStatus}</div>
                                                <div style={{ textAlign: "center",fontWeight:600,fontSize:"clamp(1rem, 2.5vw, 1.3rem)" }}>Booking Id : {bdata.BookingId}</div>
                                                <div className="receiptdiv" style={{ textAlign: "center",fontWeight:600,fontSize:"clamp(1rem, 2.5vw, 1.3rem)" }}>
                                                Booking Receipt
                                                </div>

                                                <div className="receipttable" style={{padding:'2rem 0rem '}}>

                                                <div className="table-item">

                                                    <div style={{display:'flex', justifyContent:'space-between'}}>

                                                    <div>
                                                        <div className="table-infor">
                                                        <strong className="table-text">Payment Type</strong>
                                                        <strong className="table-text">Boat Charges</strong>
                                                        {bdata.InitRowerCharge === "0.00" ? "" : <strong className="table-text">Rower Charges</strong>}
                                                        {bdata.BoatDeposit === "0.00" ? "" : <strong className="table-text">Deposit </strong>}
                                                        {this.state.BoatOtherTicket.length > 0 && <strong className="table-text">Other Facilities </strong>}
                                                        <strong className="table-text">GST</strong>
                                                        </div>
                                                    </div>

                                                    <div>
                                                        <div className="table-infor table-infor2">
                                                        <strong className="table-text">₹ {bdata.PaymentTypeName}</strong>
                                                        <strong className="table-text">₹ {bdata.InitBoatCharge}</strong>
                                                        {bdata.InitRowerCharge === "0.00" ? "" : <strong className="table-text">₹ {bdata.InitRowerCharge}</strong>}
                                                        {bdata.BoatDeposit === "0.00" ? "" : <strong className="table-text">₹ {bdata.BoatDeposit}</strong>}
                                                        {this.state.BoatOtherTicket.length > 0 && <strong className="table-text">₹ {bdata.OtherService}</strong>}
                                                        <strong className="table-text">₹ {bdata.BFDTaxAmount}</strong>
                                                        </div>
                                                    </div>

                                                    </div>

                                                

                                                    <div className="rr-1">
                                                    <div className="receipttable">
                                                        <div className="table-item">
                                                        <div style={{display:'flex', justifyContent:'space-between'}} >
                                                            <div>
                                                            <div className="table-infor">
                                                                <strong className=" table-text table-text-net">NET</strong>
                                                            </div>
                                                            </div>
                                                            <div>
                                                            <div className="table-infor table-infor2">
                                                                <strong className=" table-text table-text-net">₹ {parseFloat(bdata.InitNetAmount).toFixed(2)}</strong>

                                                            </div>
                                                            </div>
                                                        </div>
                                                        </div>
                                                    </div>
                                            </div>
                                            </div>

                                                </div>
                                            </div>
                                            </>
                                        ))
                                    }
                                </div>
                            </Container>
                        ):(!isBulkLoading &&
                            !isBulkAvailable && (
                                <Container fluid className="hotelReceipt-con py-2">
                                  <div class="receipt-nodata btn">No data found</div>
                                </Container>
                              )
                        )
                        }
                        </div>
                    </div>
                </div>
                
            </Fragment>
        )
    }
}

export default withSnackbar(TripReceipt);